<template>
  <div class="contact-info" v-show="!disabled">
    <div v-show="showHeader">
      <vs-divider class="my-8"></vs-divider>
      <div class="flex justify-end">
        <div
          @click="deleteContactInfo()"
          class="flex items-center delete-button cursor-pointer"
        >
          <feather-icon icon="Trash2Icon" svgClasses="h-6 w-6" />
        </div>
      </div>
    </div>

    <common-text-box-small
      title="所属会社"
      :required="true"
      class="mb-8"
      ref="CompanyName"
      :name="'CompanyName'"
      :showTitle="true"
    />

    <common-select-box-small
      title="担当窓口"
      :required="true"
      class="mb-8"
      :options="contacts"
      ref="Department"
      :showTitle="true"
    />
    <div class="flex items-end justify-between">
      <common-text-box-small
        title="船主担当者名"
        :required="true"
        class="w-1/2 mr-8 mb-8"
        ref="Name"
        placeholder="名前"
        :showTitle="true"
      />
      <common-text-box-small
        :required="false"
        class="w-1/2 mb-8"
        ref="NameKana"
        placeholder="カナ"
        :showTitle="true"
      />
    </div>

    <common-text-box-small
      title="電話番号（船主担当者）"
      :required="true"
      class="w-1/2 mb-8 mr-4"
      ref="Telephone"
      :showTitle="true"
      :validate="validateTelephone"
      dangerText="電話番号の形式で入力してください"
    />

    <common-text-box-small
      title="メールアドレス（船主担当者）"
      :required="true"
      class="mb-8"
      ref="MailAddress"
      :showTitle="true"
      :validate="validateMail"
      dangerText="メールアドレスの形式で入力してください"
    />
  </div>
</template>

<script>
import { HULL_INSURANCE_CONTACT_INFO } from "@/config/const";
import CommonSelectBoxSmall from '../molecules/CommonSelectBoxSmall.vue';
import CommonTextBoxSmall from '../molecules/CommonTextBoxSmall.vue';
import ValidationUtil from "@/utils/entity/ValidationUtil";

export default {
  props: {
    showHeader: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  components: {
    CommonSelectBoxSmall,
    CommonTextBoxSmall
  },

  data() {
    return {
      disabled: false,
      telephoneValue: null,
      mailValue: null,
      dangerTextTelephone: "",
      dangerTextMail: "",
    }
  },

  computed: {
    contacts() {
      return HULL_INSURANCE_CONTACT_INFO;
    },
  },

  methods: {
    deleteContactInfo() {
      this.disabled = true;
    },

    validateRequired(val) {
      return val && val.length !== 0;
    },

    validateTelephone(val) {
      if (!ValidationUtil.validateTel_jp(val)) {
        return false;
      }
      return this.validateRequired(val);
    },
    validateMail(val) {
      if (!ValidationUtil.isValidEmail(val)) {
        return false;
      }
      return this.validateRequired(val);
    },
  },

  mounted() {
    this.telephoneValue = this.$refs.Telephone.inputValue;
    this.mailValue = this.$refs.MailAddress.inputValue;
  }

}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";
.contact-info {
  .delete-button {
    padding: 9px;
    color: $icon-gray;
    border-radius: 6px;
    border: 1px solid $border-color1;
  }
}
</style>